import initPage from "./initPage"

import debuggrid from "./components/debuggrid"
import navHeight from "./components/navHeight"
import footHeight from "./components/footHeight"
import burger from "./components/burger"


function initSite(){

  /* base */
  debuggrid()
  initPage()


  navHeight()
  footHeight()




  /* Modules */
  burger()







  /*
  document.querySelector('html').addEventListener('click', (e) => {
    if (e.target.matches('.homehead--scroll')) {
      bus.emit('scrollto', wh)
    }
  })

  document.querySelector('html').addEventListener('click', (e) => {
    if (e.target.hasAttribute('data-scrollto')) {
      const targetSelector = e.target.getAttribute('data-scrollto')
      const targetEl = document.querySelector(targetSelector)
      if (targetEl) {
        let targetPos = targetEl.getBoundingClientRect().top + window.pageYOffset
        if (window.scrollType === 'virtual') {
          targetPos += st.easedReal
        }
        bus.emit('scrollto', targetPos)
      }
    }
  })

  function siteScrolled(){
    const html = document.documentElement
    const throttleScroll = _.throttle(() => {
      html.classList.toggle('js-has-scrolled', st.easedReal > 10)
    }, 50)
    bus.on('scrollupdate', throttleScroll)
  }
  siteScrolled()
  */


  function siteScrolled(){
    const html = document.documentElement
    const throttleScroll = _.throttle(() => {
      html.classList.toggle('js-has-scrolled', st.easedReal > 20)
    }, 50)
    bus.on('scrollupdate', throttleScroll)
  }
  siteScrolled()


}

export default initSite